import { Button, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelFundedVendorDefaults extends Layout {
    buttonGLControl: Button;
    buttonGLControlAdvance: Button;
    dataheaderComdata: DataHeader;
    labelAdvancedComm: Label;
    labelDirectVendors: Label;
    labelFundedVendors: Label;
    labelGLControl: Label;
    labelParsingClasses: Label;
    panelAdvCommunication: Panel;
    panelAdvancedOptions: Panel;
    panelCheck: Panel;
    panelCommunications: Panel;
    panelDirectVendors: Panel;
    panelFuel: Panel;
    panelFundedVendors: Panel;
    panelGLControl: Panel;
    sourceFuelChainCode: DataSource;
    sourceFuelDirectVendor: DataSource;
    sourceFuelFileList: DataSource;
    sourceFuelFundedVendor: DataSource;
    sourceFuelFundedVendorDefault: DataSource;
    sourceFuelProdCode: DataSource;
    sourceWirecodeDetail: DataSource;
    switchCommAdvOptions: Switch;
    switchFuelCreateGLEntries: Switch;
    switchHubUpdate: Switch;
    tabAccounts: Tab;
    tabAdvancedSettings: Tab;
    tabChainCodes: Tab;
    tabChecks: Tab;
    tabCommunications: Tab;
    tabDefaults: Tab;
    tabFuel: Tab;
    tabProducts: Tab;
    tabWireCodes: Tab;
    tableChainCodes: Table;
    tableDirectVendors: Table;
    tableFuelCodeProducts: Table;
    tableFundedVendors: Table;
    tableParsingClasses: Table;
    tableWireCodeList: Table;
    tabsetContent: Tabset;
    tabsetDefaults: Tabset;
    textboxCardProvider: Textbox;
    textboxCheckAPDivisonCode: Textbox;
    textboxCheckAPVoucher: Textbox;
    textboxCheckDuplicateSearch: Textbox;
    textboxCheckGLAccount: Textbox;
    textboxCheckVendorCode: Textbox;
    textboxChecksOrderReminder: Textbox;
    textboxCommunication: Textbox;
    textboxConnectionMode: Textbox;
    textboxConnectionType: Textbox;
    textboxDirectory: Textbox;
    textboxEmail: Textbox;
    textboxFuelAPDivisionCode: Textbox;
    textboxFuelAPVendorCode: Textbox;
    textboxFuelAPVoucher: Textbox;
    textboxFuelDiscount: Textbox;
    textboxFuelGLAccount: Textbox;
    textboxFuelHubVariance: Textbox;
    textboxGLControlCode: Textbox;
    textboxLogin: Textbox;
    textboxPassword: Textbox;
    textboxPort: Textbox;
    textboxProxyServer: Textbox;
    textboxServerName: Textbox;
}
